(function($) {
  'use strict';

  var config = {};
  var state = {
    files: [],
    selectedOptions: {},
    numCopies: 1,
    isProcessing: false,
    currentVariant: null,
    selectedDelivery: null
  };

  var ALLOWED_EXTENSIONS = ['pdf', 'jpg', 'jpeg', 'png', 'tif', 'tiff'];

  var $form, $copiesInput, $uploadZone, $fileInput, $fileList,
      $fileListItems, $fileProcessing, $orderSummary, $summaryPrintCost,
      $summaryDeliveryCost, $summaryDeliveryType, $summaryTotal, $summaryPages,
      $summaryCopies, $summaryPricePerPage, $addToCartBtn, $sizeGuideToggle, 
      $sizeGuidePanel, $shopifyFileInputs;

  function init() {
    var $configEl = $('#pattern-press-config');
    if (!$configEl.length) return;

    try {
      config = JSON.parse($configEl.text());
    } catch (e) {
      console.error('Config parse error:', e);
      return;
    }

    cacheElements();
    bindEvents();
    initializeState();
    updateUI();
  }

  function cacheElements() {
    $form = $('#pattern-print-form');
    $copiesInput = $('#num-copies');
    $uploadZone = $('#file-upload-zone');
    $fileInput = $('#file-input');
    $fileList = $('#file-list');
    $fileListItems = $('#file-list-items');
    $fileProcessing = $('#file-processing');
    $orderSummary = $('#order-summary');
    $summaryPrintCost = $('#summary-print-cost');
    $summaryDeliveryCost = $('#summary-delivery-cost');
    $summaryDeliveryType = $('#summary-delivery-type');
    $summaryTotal = $('#summary-total');
    $summaryPages = $('#summary-pages');
    $summaryCopies = $('#summary-copies');
    $summaryPricePerPage = $('#summary-price-per-page');
    $addToCartBtn = $('#add-to-cart-btn');
    $sizeGuideToggle = $('.size-guide-toggle');
    $sizeGuidePanel = $('.size-guide-panel');
    $shopifyFileInputs = $('#shopify-file-inputs');
  }

  function initializeState() {
    state.selectedOptions = {};
    
    $form.find('select.product-option').each(function() {
      var $el = $(this);
      state.selectedOptions[$el.data('option-name')] = $el.val() || '';
    });

    $form.find('input.product-option-radio:checked').each(function() {
      var $el = $(this);
      state.selectedOptions[$el.data('option-name')] = $el.val();
    });

    var $checkedDelivery = $form.find('input.delivery-option-radio:checked');
    if ($checkedDelivery.length) {
      state.selectedDelivery = {
        id: null, //parseInt($checkedDelivery.data('variant-id'))
        title: $checkedDelivery.val(), //$checkedDelivery.data('variant-title')
        price: 0 //parseInt($checkedDelivery.data('variant-price'))
      };
    }

    state.numCopies = parseInt($copiesInput.val(), 10) || 1;
    updateSelectedVariant();
    updateSelectedDeliverAvailablity();
    updateHiddenInputs();
  }

  function bindEvents() {
    $form.find('select.product-option').on('change', handleOptionChange);
    $form.find('input.product-option-radio').on('change', handleOptionChange);
    $form.find('input.delivery-option-radio').on('change', handleDeliveryChange);
    $copiesInput.on('input change', handleCopiesChange);

    $uploadZone.on('click', function(e) {
      if (e.target === $fileInput[0]) return;
      e.preventDefault();
      e.stopPropagation();
      $fileInput[0].click();
    });

    $fileInput.on('click', function(e) {
      e.stopPropagation();
    });

    $uploadZone.on('dragover', function(e) {
      e.preventDefault();
      e.stopPropagation();
      $(this).addClass('drag-over');
    });

    $uploadZone.on('dragleave', function(e) {
      e.preventDefault();
      e.stopPropagation();
      $(this).removeClass('drag-over');
    });

    $uploadZone.on('drop', function(e) {
      e.preventDefault();
      e.stopPropagation();
      $(this).removeClass('drag-over');
      var files = e.originalEvent.dataTransfer.files;
      if (files.length) {
        processFiles(files);
      }
    });

    $fileInput.on('change', function() {
      if (this.files.length) {
        processFiles(this.files);
        $(this).val('');
      }
    });

    $sizeGuideToggle.on('click', function(e) {
      e.preventDefault();
      var expanded = $(this).attr('aria-expanded') === 'true';
      $(this).attr('aria-expanded', !expanded);
      $sizeGuidePanel.prop('hidden', expanded);
    });

    $form.on('submit', handleFormSubmit);

    $fileListItems.on('click', '.file-remove', function(e) {
      e.preventDefault();
      e.stopPropagation();
      removeFile($(this).closest('.file-item').data('file-id'));
    });
  }

  function handleOptionChange() {
    var $el = $(this);
    var optionName = $el.data('option-name');
    state.selectedOptions[optionName] = $el.val();
    updateSelectedVariant();
    updateSelectedDeliverAvailablity();
    updateFilePrices();
    updateHiddenInputs();
    updateUI();
  }

  function handleDeliveryChange() {
    var $el = $(this);
    state.selectedDelivery = {
      id: null, //parseInt($el.data('variant-id'))
      title: $el.val(), //data('variant-title')
      price: 0 //parseInt($el.data('variant-price'))
    };
    handleOptionChange();
    updateUI();
  }

  function handleCopiesChange() {
    var val = parseInt($copiesInput.val(), 10);
    state.numCopies = isNaN(val) || val < 1 ? 1 : Math.min(val, 100);
    $copiesInput.val(state.numCopies);
    updateFilePrices();
    updateHiddenInputs();
    updateUI();
  }
  function updateSelectedDeliverAvailablity() {
    const allowedDeliveries = $('[allowed-deliveries]:checked').attr('allowed-deliveries');

    // If no restrictions, do nothing
    if (!allowedDeliveries) return;

    let hasAvailableOption = false;
    let firstAvailableInput = null;

    $('[data-option-name="delivery"] input').each(function() {
      const $input = $(this);
      const $label = $input.closest('.radio-label');
      const delivery = $input.val();
      
      if (allowedDeliveries.includes(delivery)) {
        // Enable this option
        $input.prop('disabled', false);
        $label.removeClass('disabled');
        hasAvailableOption = true;
        
        // Store first available option
        if (!firstAvailableInput) {
          firstAvailableInput = $input;
        }
      } else {
        // Disable this option
        $input.prop('checked', false).prop('disabled', true);
        $label.addClass('disabled');
      }
    });

    // If current selection is disabled, select first available option
    if (hasAvailableOption) {
      const $checked = $('[data-option-name="delivery"] input:checked');
      if (!$checked.length || $checked.prop('disabled')) {
        firstAvailableInput.prop('checked', true).trigger('change');
      }
    }
  }
  function updateSelectedVariant() {
    var opt = state.selectedOptions;
    state.currentVariant = null;
    
    $.each(config.product.variants, function(i, v) {
      if (v.option1 === opt.Size && v.option2 === opt.Type && v.option3 === opt.Colour) {
        state.currentVariant = v;
        return false;
      }
    });
  }

  function getVariantPricePerPage() {
    if (state.currentVariant) {
      return state.currentVariant.price;
    }
    return 0;
  }

  // Update hidden form inputs for native submission
  function updateHiddenInputs() {
    if (state.currentVariant) {
      $('#main-variant-id').val(state.currentVariant.id);
    }
    
    var quantity = getTotalPages() * state.numCopies;
    $('#main-quantity').val(quantity > 0 ? quantity : 1);
    
    $('#prop-size').val(state.selectedOptions.Size || '');
    $('#prop-colour').val(state.selectedOptions.Colour || '');
    $('#prop-copies').val(state.numCopies);
    $('#prop-pages').val(getTotalPages());
    
    var filesInfo = $.map(state.files, function(f) {
      return f.name + ' (' + f.pages + ' page' + (f.pages > 1 ? 's' : '') + ')';
    }).join(', ');
    $('#prop-files-info').val(filesInfo);
    // $('#deliver-variant-id').val(state.selectedDelivery.id);
    // $('#deliver-variant-parent').val(state.currentVariant.id);
    // if(calculateTotalPrintCost() < 1000){
    //   $('.min-variant-id').prop('disabled', false);
    //   $('.min-variant-parent').val(state.currentVariant.id).prop('disabled', false);
    // }else{
    //   $('.min-variant-id').prop('disabled', true);
    //   $('.min-variant-parent').prop('disabled', true);
    // }
  }

  // Create actual file inputs for Shopify form submission
  function updateShopifyFileInputs() {
    $shopifyFileInputs.empty();

    $.each(state.files, function(i, fileData) {
      var inputName = 'properties[File ' + (i + 1) + ']';
      var $input = $('<input>', {
        type: 'file',
        name: inputName,
        'data-file-id': fileData.id
      });

      // Use DataTransfer to set the file on the input
      try {
        var dt = new DataTransfer();
        dt.items.add(fileData.file);
        $input[0].files = dt.files;
      } catch (e) {
        console.error('DataTransfer not supported:', e);
      }

      $shopifyFileInputs.append($input);
    });
  }

  function processFiles(fileList) {
    state.isProcessing = true;
    $fileProcessing.show();

    var validFiles = [];
    var errors = [];

    $.each(fileList, function(i, file) {
      var validation = validateFile(file);
      if (validation.valid) {
        validFiles.push(file);
      } else {
        errors.push(file.name + ': ' + validation.error);
      }
    });

    if (errors.length) {
      alert('Some files could not be added:\n\n' + errors.join('\n'));
    }

    if (validFiles.length === 0) {
      state.isProcessing = false;
      $fileProcessing.hide();
      updateUI();
      return;
    }

    var promises = $.map(validFiles, function(file) {
      return processFile(file);
    });

    $.when.apply($, promises).always(function() {
      state.isProcessing = false;
      $fileProcessing.hide();
      updateHiddenInputs();
      updateShopifyFileInputs();
      updateUI();
    });
  }

  function processFile(file) {
    var deferred = $.Deferred();

    var fileData = {
      id: 'f_' + Math.random().toString(36).substr(2, 9),
      file: file,
      name: file.name,
      size: file.size,
      type: getFileType(file),
      pages: 1,
      pagesLoading: true,
      price: 0
    };

    state.files.push(fileData);
    renderFileItem(fileData);

    if (fileData.type === 'pdf') {
      getPdfPageCount(file)
        .done(function(count) { fileData.pages = count; })
        .fail(function() { fileData.pages = 1; })
        .always(function() {
          fileData.pagesLoading = false;
          fileData.price = calculateFilePrice(fileData);
          updateFileItemUI(fileData);
          updateHiddenInputs();
          updateShopifyFileInputs();
          updateUI();
          deferred.resolve();
        });
    } else {
      fileData.pagesLoading = false;
      fileData.price = calculateFilePrice(fileData);
      updateFileItemUI(fileData);
      deferred.resolve();
    }

    return deferred.promise();
  }

  function validateFile(file) {
    var ext = file.name.split('.').pop().toLowerCase();
    if ($.inArray(ext, ALLOWED_EXTENSIONS) === -1) {
      return { valid: false, error: 'File type not supported' };
    }
    if (file.size > config.maxFileSize * 1024 * 1024) {
      return { valid: false, error: 'File exceeds ' + config.maxFileSize + 'MB' };
    }
    var duplicate = false;
    $.each(state.files, function(i, f) {
      if (f.name === file.name && f.size === file.size) {
        duplicate = true;
        return false;
      }
    });
    if (duplicate) {
      return { valid: false, error: 'File already added' };
    }
    return { valid: true };
  }

  function getFileType(file) {
    var ext = file.name.split('.').pop().toLowerCase();
    return ext === 'pdf' ? 'pdf' : 'image';
  }

  function getPdfPageCount(file) {
    var deferred = $.Deferred();
    var reader = new FileReader();

    reader.onload = function(e) {
      var data = new Uint8Array(e.target.result);
      pdfjsLib.getDocument({ data: data }).promise
        .then(function(pdf) { deferred.resolve(pdf.numPages); })
        .catch(function() { deferred.reject(); });
    };

    reader.onerror = function() { deferred.reject(); };
    reader.readAsArrayBuffer(file);

    return deferred.promise();
  }

  function removeFile(fileId) {
    var idx = -1;
    $.each(state.files, function(i, f) {
      if (f.id === fileId) { idx = i; return false; }
    });
    if (idx > -1) {
      state.files.splice(idx, 1);
      $fileListItems.find('[data-file-id="' + fileId + '"]').remove();
      updateHiddenInputs();
      updateShopifyFileInputs();
      updateUI();
    }
  }

  function calculateFilePrice(fileData) {
    var pricePerPage = getVariantPricePerPage();
    return pricePerPage * fileData.pages * state.numCopies;
  }

  function updateFilePrices() {
    $.each(state.files, function(i, f) {
      f.price = calculateFilePrice(f);
      updateFileItemUI(f);
    });
  }

  function calculateTotalPrintCost() {
    var total = 0;
    $.each(state.files, function(i, f) { total += f.price; });
    return total;
  }

  function getDeliveryCost() {
    if (state.selectedDelivery) {
      return state.selectedDelivery.price;
    }
    return 0;
  }

  function getTotalPages() {
    var total = 0;
    $.each(state.files, function(i, f) { total += f.pages; });
    return total;
  }

  function renderFileItem(fileData) {
    var icon = fileData.type === 'pdf' 
      ? '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline></svg>'
      : '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><circle cx="8.5" cy="8.5" r="1.5"></circle><polyline points="21 15 16 10 5 21"></polyline></svg>';

    var html = '<div class="file-item" data-file-id="' + fileData.id + '">' +
      '<div class="file-item-info">' +
        '<div class="file-icon">' + icon + '</div>' +
        '<div class="file-details">' +
          '<div class="file-name">' + escapeHtml(fileData.name) + '</div>' +
          '<div class="file-size">' + formatFileSize(fileData.size) + '</div>' +
        '</div>' +
      '</div>' +
      '<div class="file-pages" data-pages>' + (fileData.pagesLoading ? '...' : fileData.pages) + '</div>' +
      '<div class="file-price" data-price>' + formatMoney(fileData.price) + '</div>' +
      '<button type="button" class="file-remove" aria-label="Remove">' +
        '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">' +
          '<line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line>' +
        '</svg>' +
      '</button>' +
    '</div>';

    $fileListItems.append(html);
  }

  function updateFileItemUI(fileData) {
    var $item = $fileListItems.find('[data-file-id="' + fileData.id + '"]');
    $item.find('[data-pages]').text(fileData.pages);
    $item.find('[data-price]').text(formatMoney(fileData.price));
  }

  function updateUI() {
    $fileList.toggle(state.files.length > 0);

    var showSummary = state.files.length > 0 && state.currentVariant;
    if (showSummary) {
      $orderSummary.show();
      $summaryPages.text(getTotalPages());
      $summaryCopies.text(state.numCopies);
      $summaryPricePerPage.text(formatMoney(getVariantPricePerPage()));
      $summaryPrintCost.text(formatMoney(calculateTotalPrintCost()));
      $summaryDeliveryType.text(state.selectedDelivery ? state.selectedDelivery.title : 'N/A');
      $summaryDeliveryCost.text(formatMoney(getDeliveryCost()));
      $summaryTotal.text(formatMoney(calculateTotalPrintCost() + getDeliveryCost()));
    } else {
      $orderSummary.hide();
    }

    var canSubmit = state.files.length > 0 && 
                    state.currentVariant && 
                    state.selectedOptions.Size &&
                    !state.isProcessing;
    $addToCartBtn.prop('disabled', !canSubmit);
  }

  function handleFormSubmit(e) {
    e.preventDefault();
    // Validate first
    if (!state.files.length) {
      alert('Please upload at least one file.');
      return false;
    }
    if (!state.selectedOptions.Size) {
      alert('Please select a paper size.');
      return false;
    }
    if (!state.currentVariant) {
      alert('Please select all options.');
      return false;
    }

    // Update all hidden inputs before submit
    updateHiddenInputs();
    updateShopifyFileInputs();

    // Show loading state
    var $btnText = $addToCartBtn.find('.btn-text');
    var $btnLoading = $addToCartBtn.find('.btn-loading');
    $addToCartBtn.prop('disabled', true);
    $btnText.hide();
    $btnLoading.show();
    const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
      .map((el) => el.dataset.sectionId)
      .filter(Boolean);
    // Build FormData from the form
    var formData = new FormData($form[0]);
    if (sectionIds.length) {
      formData.append('sections', sectionIds.join(','));
    }
    // Submit via AJAX
    $.ajax({
      url: '/cart/add.js',
      type: 'POST',
      data: formData,
      processData: false,
      contentType: false,
      dataType: 'json'
    })
    .done(function(response) {
      console.log('Added to cart:', response);
      window.manualCartRefresh(response);
      $('.file-remove').trigger('click');
    })
    .fail(function(xhr) {
      var errorMsg = 'Error adding to cart.';
      try {
        var response = JSON.parse(xhr.responseText);
        if (response.description) {
          errorMsg = response.description;
        }
      } catch (e) {}
      alert(errorMsg);
    })
    .always(function() {
      // window.location.reload();
      $addToCartBtn.prop('disabled', false);
      $btnText.show();
      $btnLoading.hide();
    });

    // If no delivery product, allow native form submission
    return true;
  }

  function formatMoney(cents) {
    if (config.moneyFormat) {
      var amount = (cents / 100).toFixed(2);
      return config.moneyFormat
        .replace('{{amount}}', amount)
        .replace('{{amount_no_decimals}}', Math.round(cents / 100))
        .replace('{{amount_with_comma_separator}}', amount.replace('.', ','));
    }
    return '£' + (cents / 100).toFixed(2);
  }

  function formatFileSize(bytes) {
    if (bytes === 0) return '0 B';
    var k = 1024;
    var sizes = ['B', 'KB', 'MB', 'GB'];
    var i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
  }

  function escapeHtml(text) {
    var div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  $(document).ready(function() {
    if ($('#pattern-print-form').length) {
      init();
    }
  });

})(jQuery);